import { REDUCERS } from '@/constants/reducers';

export function theme(state, action) {
    switch (action.type) {
        case REDUCERS.UPDATE_THEME:
            return { ...state, theme: action.payload };
        default:
            return state;
    }
}
